import { FC, PropsWithChildren } from 'react';

import { Navigate, useLocation } from 'react-router';

import { addTag } from '@core';
import { boothIdAtom, useSyncAtom } from '@store';

import {
    useBooth,
    useBoothSessionRefresh,
    useBoothSessionManager,
    useBoothEvents,
    useBoothEndpoint,
    useBoothInfo,
} from './hooks';
import { LoadingScreen } from './screens/LoadingScreen/LoadingScreen';
import { UserProvider } from './UserProvider';

type UserProviderProps = {
    authPaths: string[];
    loginPath: string;
    boothLoginPath: string;
};

export const KioskProvider: FC<PropsWithChildren<UserProviderProps>> = ({
    children,
    authPaths,
    loginPath,
    boothLoginPath,
}) => {
    const { data: booth, isLoading } = useBooth();
    const location = useLocation();

    addTag('boothUserId', booth?.id ?? 'None');

    const { data: boothInfo } = useBoothInfo();
    useSyncAtom(boothIdAtom, boothInfo?.id, true);

    // `useUserEvents` are in `UserProvider`
    useBoothEvents();
    useBoothSessionManager();
    useBoothSessionRefresh();
    useBoothEndpoint();

    if (isLoading) {
        return <LoadingScreen message="Loading application..." />;
    }
    if (!booth && !authPaths.includes(location.pathname)) {
        return <Navigate replace to={boothLoginPath} />;
    }
    return (
        <UserProvider authPaths={authPaths} loginPath={loginPath}>
            {children}
        </UserProvider>
    );
};
